<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">
          View Own Vehicle Expense - ({{
            expense.vehicle?.vehicle_no ?? "N/A"
          }})
        </h1>

        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" (click)="backTo()">
            Own Vehicle Expense
          </li>
          <li class="breadcrumb-item">View</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3" *ngIf="expense && !isLoading">
    <div class="col-xl-12">
      <div class="contentbox">
        <div class="row account">
          <div class="col-xl-12 mb-4">
            <div class="detailsBox">
              <h4>Basic Details</h4>

              <div class="row">
                <div class="col-xl-3">
                  <label>Vehicle</label>
                  <h5>{{ expense.vehicle?.vehicle_no ?? "N/A" }}</h5>
                </div>
                <div class="col-xl-3">
                  <label>Vehicle Type</label>
                  <h5>{{ expense.vehicle?.type ?? "N/A" }}</h5>
                </div>
                <div class="col-xl-3">
                  <label>Expense Date</label>
                  <h5>{{ expense.expenseDate | date: "mediumDate" }}</h5>
                </div>

                <div class="col-xl-3">
                  <label>Location</label>
                  <h5>{{ expense.location || "N/A" }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12 mb-4">
            <div class="detailsBox">
              <h4>Meter Readings</h4>

              <div class="row">
                <div class="col-xl-3">
                  <label>Start Meter Reading</label>
                  <h5>{{ expense.startMeterReading }}</h5>
                </div>

                <div class="col-xl-3">
                  <label>End Meter Reading</label>
                  <h5>{{ expense.endMeterReading }}</h5>
                </div>

                <div class="col-xl-3">
                  <label>Total Kms</label>
                  <h5>{{ expense.totalKms }}</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12 mb-4">
            <div class="detailsBox">
              <h4>Amounts</h4>

              <div class="row">
                <div class="col-xl-3">
                  <label>Driver Advance</label>
                  <h5>{{ expense.driverAdvance ?? 0 }}</h5>
                </div>

                <div class="col-xl-3">
                  <label>Loader Advance</label>
                  <h5>{{ expense.loaderAdvance ?? 0 }}</h5>
                </div>
                <div class="col-xl-3">
                  <label>Police Amount</label>
                  <h5>{{ expense.policeAmount ?? 0 }}</h5>
                </div>
              </div>
              <div class="row">

                <div class="col-xl-3">
                  <label>Fuel Amount</label>
                  <h5>{{ expense.fuelExpense ?? 0 }}</h5>
                </div>
                <div class="col-xl-3">
                  <label>Other Amount</label>
                  <h5>{{ expense.other ?? 0 }}</h5>
                </div>

                <div class="col-xl-6">
                  <label>Other Description</label>
                  <h5>{{ expense.otherDescription || "N/A" }}</h5>
                </div>

                <div class="row">
                  <div class="col-xl-3">
                    <label>Total Amount</label>
                    <h5>{{ expense.totalAmount ?? 0 }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-xl-12 mb-4">
            <div class="detailsBox">
              <h4>Other Expenses</h4>

              
            </div>
          </div> -->

          <!-- <div class="col-xl-12 mb-4">
            <div class="detailsBox">
              <h4>Total</h4>


            </div>
          </div> -->

          <div class="col-xl-12 mb-4" *ngIf="expense.attachments?.length">
            <div class="detailsBox">
              <h4>Attachments</h4>

              <ul class="attachment-list mt-2">
                <li
                  *ngFor="let file of expense.attachments"
                  class="attachment-item mb-1"
                >
                  <a
                    [href]="apiUrl + '/' + file"
                    target="_blank"
                    class="attachment-name"
                  >
                    {{ file.split("/").pop() }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-xl-12 mb-2">
            <div class="detailsBox">
              <h4>Audit Information</h4>

              <div class="row">
                <div class="col-xl-6">
                  <label>Created By</label>
                  <h5>{{ expense.createdBy?.full_name || "N/A" }}</h5>
                </div>

                <div class="col-xl-6">
                  <label>Created At</label>
                  <h5>{{ expense.createdAt | date: "dd-MM-yyyy HH:mm" }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center mt-4">
    Loading expense details...
  </div>
</div>
